<template>
  <div>
    <div class="page" v-if="store">
      <breadcrumb />
      <div class="info">
        <div class="title-row">
          <h1 class="gyra-h1-normal-serif">
            {{ `store.${storeName}` | translate }}
          </h1>
          <div class="guide-me">
            <p>
              {{ "store_page.titles.map" | translate }}
            </p>
            <icon-button
              class="icon"
              variant="secondary"
              icon="x"
              @click="navigateToStoreOnMap"
            />
          </div>
        </div>
        <div class="bottom-row">
          <div class="left">
            <div
              class="store-image"
              :style="{
                backgroundImage: `url(${require(`../assets/images/stores/${storeName}.jpg`)})`
              }"
            ></div>
          </div>
          <div class="right">
            <p class="gyra-p-normal-sans">
              {{ `store_page.long_descriptions.${storeName}` | translate }}
            </p>
            <div class="emoji-column">
              <div class="emoji" v-for="(tag, i) in store.tags" :key="i">
                <div class="gyra-p-normal-sans em">{{ tag | emoji }}</div>
                <div class="gyra-p-normal-sans desc">
                  {{ `store_map.tooltips.${tag}` | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 class="more gyra-h1-normal-serif">
        {{ `store_page.titles.products` | translate }}
      </h1>
      <div v-if="hasProducts" class="products">
        <div class="content-grid">
          <product-card
            v-for="(product, j) in productsToShow"
            :product="product"
            :key="j"
            @card-clicked="visitProductPage"
            class="product-card"
          />
        </div>
        <bottom-loader
          @intersection="loadMoreItems()"
          :stop-condition="allItemsLoaded"
        ></bottom-loader>
      </div>
    </div>
    <gyra-spinner v-else></gyra-spinner>
  </div>
</template>

<script>
import { getProductsForStore, getStoreByName } from "../services/api";
import ProductCard from "../components/molecules/product-card";
import BottomLoader from "../components/atoms/bottom-loader";
import GyraSpinner from "../components/atoms/gyra-spinner";
import Breadcrumb from "../components/molecules/breadcrumb";
import IconButton from "../components/atoms/icon-button";

export default {
  name: "StorePage",
  components: {
    IconButton,
    Breadcrumb,
    GyraSpinner,
    BottomLoader,
    ProductCard
  },
  data() {
    return {
      products: null,
      showCount: 20,
      store: null
    };
  },
  methods: {
    async getProducts() {
      const response = await getProductsForStore(this.$route.params.store);
      this.products = response.data;
    },
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    },
    loadMoreItems() {
      this.showCount += 20;
    },
    async getStoreInfo() {
      const response = await getStoreByName(this.$route.params.store);
      this.store = response.data[0];
    },
    navigateToStoreOnMap() {
      this.$router.go(-1);
    }
  },
  computed: {
    hasProducts() {
      return this.products && this.products.length > 0;
    },
    allItemsLoaded() {
      return this.products.length <= this.showCount;
    },
    productsToShow() {
      if (!this.products) return;
      const index = !this.allItemsLoaded
        ? this.showCount
        : this.products.length;
      return this.products.slice(0, index);
    },
    storeName() {
      return this.$route.params.store;
    }
  },
  mounted() {
    this.getProducts();
    this.getStoreInfo();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.page {
}
.info {
  justify-content: center;
  @media (min-width: $gyra-breakpoint-md) {
    justify-content: unset;
  }
  background-color: $gyra-grey-lightest;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
}
.title-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: $gyra-margin-sides-mobile;
  @media (min-width: $gyra-breakpoint-lg) {
    margin-left: $gyra-margin-sides;
  }
  margin-top: 25px;

  h1 {
    margin: 0;
    font-size: 30px;
    @media (min-width: $gyra-breakpoint-sm) {
      font-size: 50px;
    }
  }

  .guide-me {
    margin-right: $gyra-margin-sides-mobile;
    @media (min-width: $gyra-breakpoint-md) {
      margin-right: 156px;
    }
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    width: 50px;
    @media (min-width: $gyra-breakpoint-sm) {
      width: 150px;
    }
    p {
      display: none;
      @media (min-width: $gyra-breakpoint-sm) {
        display: inline;
      }
      margin-bottom: 0;
      font-weight: bold;
    }

    .icon {
    }
  }
}
.bottom-row {
  margin: 75px 23px 70px 23px;
  @media (min-width: $gyra-breakpoint-md) {
    margin: 75px 156px 70px 156px;
  }
  display: flex;
  flex-direction: column;
  @media (min-width: $gyra-breakpoint-xl) {
    flex-direction: row;
  }
}
.left {
  display: flex;
  justify-content: center;
  @media (min-width: $gyra-breakpoint-md) {
    justify-content: unset;
  }

  .store-image {
    display: flex;
    justify-content: center;
    width: 100%;
    height: calc(0.52 * 100vw);
    @media (min-width: $gyra-breakpoint-md) {
      justify-content: unset;
    }
    /*width: 294px;*/
    /*height: 153px;*/
    /*    @media (min-width: $gyra-breakpoint-sm) {
      width: 368px;
      height: 192px;
    }*/
    @media (min-width: $gyra-breakpoint-md) {
      width: 558px;
      height: 385px;
    }
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: 10px;
    box-shadow: 10px 10px 50px 0 rgba(0, 0, 0, 0.16);
  }
}
.right {
  margin-left: 0;
  margin-top: 24px;
  display: flex;
  flex-direction: column-reverse;
  @media (min-width: $gyra-breakpoint-xl) {
    margin-left: 57px;
    margin-top: 0;
    flex-direction: column;
  }

  p {
    font-size: 12px;
    margin-top: 24px;
    @media (min-width: $gyra-breakpoint-md) {
      font-size: 16px;
      margin-top: 0;
    }
  }
}

.content-grid {
  display: grid;
  grid-gap: 2rem;
  justify-items: center;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  @media (min-width: 1000px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
  @media (min-width: 1328px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
  @media (min-width: 1828px) {
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  }
}

.more {
  font-size: 30px;
  margin: 40px $gyra-margin-sides-mobile 0 $gyra-margin-sides-mobile;
  @media (min-width: $gyra-breakpoint-lg) {
    font-size: 50px;
    margin: 40px $gyra-margin-sides 0 $gyra-margin-sides;
  }
}
.products {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 40px 0 0 0;
  @media (min-width: $gyra-breakpoint-lg) {
    margin: 60px $gyra-margin-sides 0 $gyra-margin-sides;
  }
}

.emoji-column {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (min-width: $gyra-breakpoint-xl) {
    flex-direction: column;
  }
}
.emoji {
  min-width: fit-content;
  margin-top: 20px;
  margin-right: 48px;
  @media (min-width: $gyra-breakpoint-xl) {
    margin-top: 20px;
    margin-right: 0;
  }

  display: flex;
  flex-direction: row;
  div {
    font-weight: bold;
  }

  .desc {
    margin-left: 15px;
  }
}
</style>
